import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // If user is already logged in, redirect to home
  if (authService.isAuthenticated() === true) {
    return router.createUrlTree(['/home']);
  }

  // If user login state is unknown, wait for it to resolve before allowing access
  if (authService.isAuthenticated() === null) {
    return authService.ensureAuthenticated().pipe(
      take(1),
      map((isAuth) => {
        if (isAuth) {
          return router.createUrlTree(['/home']);
        }
        return true;
      }),
    );
  }

  // If not logged in, allow access to login/activate pages
  return true;
};
